export default function Instrucciones() {
  const pasos = [
    {
      icon: 'ri-user-line',
      titulo: 'Complete sus Datos Personales',
      desc: 'Ingrese su nombre, apellido, correo electrónico institucional, teléfono, profesión y postgrado si corresponde (maestría, doctorado, especialidad, etc.).',
    },
    {
      icon: 'ri-briefcase-line',
      titulo: 'Indique su Cargo y Profesión',
      desc: 'Seleccione si es Docente o Estudiante, ingrese su profesión y el cargo o título que desempeña en la institución.',
    },
    {
      icon: 'ri-article-line',
      titulo: 'Registre sus Publicaciones',
      desc: 'Sección opcional. Si no tiene publicaciones, puede dejarla en blanco. Si tiene trabajos finalizados, puede registrar sus artículos, libros, ponencias o tesis aprobadas.',
    },
    {
      icon: 'ri-send-plane-line',
      titulo: 'Envíe el Formulario',
      desc: 'Revise la información ingresada y haga clic en "Enviar Registro" para completar su inscripción en el censo de investigadores.',
    },
  ];

  return (
    <section id="instrucciones" className="max-w-5xl mx-auto px-6 mt-10">
      <div className="bg-[#00426A] rounded-xl p-7">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg">
            <i className="ri-information-line text-white text-lg" />
          </div>
          <h2 className="text-white font-bold text-lg tracking-wide">
            Instrucciones para el llenado del formulario
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {pasos.map((paso, i) => (
            <div
              key={i}
              className="flex items-start gap-3 bg-[#02acb5] rounded-lg p-4"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full shrink-0 mt-0.5">
                <span className="text-white text-sm font-bold">{i + 1}</span>
              </div>
              <div>
                <p className="text-white font-semibold text-sm mb-1">
                  {paso.titulo}
                </p>
                <p className="text-white/75 text-xs leading-relaxed">
                  {paso.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-white/60 text-xs mt-4 leading-relaxed">
          <strong className="text-white/80">Nota:</strong> Los campos marcados con{' '}
          <span className="text-amber-300 font-bold">*</span> son obligatorios.
          Asegúrese de utilizar su correo electrónico institucional para facilitar
          la verificación de datos.
        </p>
      </div>
    </section>
  );
}
